export default "__VITE_ASSET__1$$AwrHk__"